import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

function getAdminAuthConfig() {
  const token = sessionStorage.getItem("accessToken");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

/**
 * Get FAQ list
 */
export async function getFaqsApi(payload = {}) {
  try {
    const fd = new FormData();

    fd.append("page", payload.page || 1);
    fd.append("limit", payload.limit || 10);
    fd.append("search", payload.search || "");
    fd.append("course_id", payload.course_id || "");
    fd.append("category_id", payload.category_id || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/faqs/list`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get FAQs Error:", err);

    return {
      status: false,
      type: "danger",
      success: "FAQs fetch failed",
    };
  }
}

/**
 * Get FAQ stats
 */
export async function getFaqStatsApi() {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/faqs/stats`,
      {},
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get FAQ Stats Error:", err);

    return {
      status: false,
      type: "danger",
      success: "FAQ stats fetch failed",
    };
  }
}

/**
 * Get single FAQ
 */
export async function getFaqApi(faqId) {
  try {
    const fd = new FormData();

    fd.append("faq_id", faqId || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/faqs/view`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get FAQ Error:", err);

    return {
      status: false,
      type: "danger",
      success: "FAQ fetch failed",
    };
  }
}

/**
 * Create FAQ
 */
export async function createFaqApi(payload = {}) {
  try {
    const fd = new FormData();

    fd.append("faq_parent", payload.faq_parent || "");
    fd.append("faq_parent_type", payload.faq_parent_type || "");
    fd.append("faq_title", payload.faq_title || "");
    fd.append("faq_meta_title", payload.faq_meta_title || "");
    fd.append("faq_meta_keyword", payload.faq_meta_keyword || "");
    fd.append("faq_desc", payload.faq_desc || "");
    fd.append("faq_cat", payload.faq_cat || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/faqs/create`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Create FAQ Error:", err);

    return {
      status: false,
      type: "danger",
      success: "FAQ creation failed",
    };
  }
}

/**
 * Update FAQ
 */
export async function updateFaqApi(payload = {}) {
  try {
    const fd = new FormData();

    fd.append("faq_id", payload.faq_id || "");
    fd.append("faq_parent", payload.faq_parent || "");
    fd.append("faq_parent_type", payload.faq_parent_type || "");
    fd.append("faq_title", payload.faq_title || "");
    fd.append("faq_meta_title", payload.faq_meta_title || "");
    fd.append("faq_meta_keyword", payload.faq_meta_keyword || "");
    fd.append("faq_desc", payload.faq_desc || "");
    fd.append("faq_cat", payload.faq_cat || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/faqs/update`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Update FAQ Error:", err);

    return {
      status: false,
      type: "danger",
      success: "FAQ update failed",
    };
  }
}

/**
 * Delete FAQ
 */
export async function deleteFaqApi(faqId) {
  try {
    const fd = new FormData();

    fd.append("faq_id", faqId || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/faqs/delete`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Delete FAQ Error:", err);

    return {
      status: false,
      type: "danger",
      success: "FAQ deletion failed",
    };
  }
}